import SourceTooltip from 'common/components/SourceTooltip';
import { cn } from 'common/utils';
import React from 'react';

const AIStatusWarning = ({ show, tooltipContent, icon, className }) => {
  return (
    show && (
      <div className={cn('absolute', className)}>
        <SourceTooltip content={tooltipContent}>
          {icon}
        </SourceTooltip>
      </div>
    )
  );
};

export default AIStatusWarning;
